import React, { useState, useEffect } from "react";
import {
  Segment,
  Tab,
  Menu,
  Grid,
  Card,
  Button,
  Item,
  Icon,
  Input,
  Dropdown,
} from "semantic-ui-react";
import AtricleTimeLine from "./ArticleTimeLine";
import "../Css/ArticleTab.css";
import AdminContent from "./AdminContent";
import { currentLang, Localization, Localizator } from "../utils/lang";
import {
  addNewCategory,
  getArticlesPreview,
  getCategorys,
} from "../utils/articleFuncton";
//通用文章列表
function ArticlesTab({ menuItems }) {
  //const panes = panes;
  const [cats, setCats] = useState([]);
  const [activeItem, setActiveItem] = useState("all"); //("b1xFVJOHXs7436A1Ltiu"); //選擇中的分類
  const [items, setItems] = useState([]);

  const [isBusy, setIsBusy] = useState(true);
  const [isOpenNewCatInput, setIsOpenNewCatInput] = useState(false);
  const [newCatInput, setNewCatInput] = useState("");
  var sortedItems = [];
  //const [last_aid, setLast_aid] = useState(null);
  var last_aid = null;

  //取得分類
  useEffect(() => {
    if (!menuItems) {
      getCategorys().then((res) => {
        console.log(res.docs);
        var items = [
          { id: "all", catName: Localization["all"] },
        ];
        for (var i = 0; i < res.docs.length; i++) {
          items.push({
            id: res.docs[i]?.id,
            catName: res.docs[i]?.data()?.catName,
          });
        }
        console.log(items);
        setCats(items);
        //setActiveItem(items[0].id);
      });
    } else {
      setCats(menuItems);
    }

    //Window Scroll => 換頁
    window.onscroll = (ev) => {
      //TODO: 優化： (會爆讀)
      /*
      if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {        
        // you're at the bottom of the page        
        //GetArticlesFunction()
      }*/
    };
  }, []);

  //依照讀取分類下文章
  useEffect(async () => {
    GetArticlesFunction();
  }, [activeItem]);

  function GetArticlesFunction() {
    getArticlesPreview({
      catid: activeItem,
      startAfter: last_aid,
      orderBy: "publishDate",
    }).then((res) => {
      var _previousItem = { year: 0, month: 0, index: 0 };

      res.forEach((doc, i) => {
        //TODO: 文字
        //const _content = res[i].data().data[currentLang];
        //console.log(_content)

        /* 產生文章Card*/
        var cardData = {
          title: doc.data().title[currentLang],// _content?.title,
          aid: doc.id,
          path: "/article/" + doc.id,
          dateTime: doc.data().publishDate,
          meta: doc.data().tag.join(","),
          thumbNail: doc.data().thumbnail,
        };

        //用年分切割文章
        var pb_time = new Date(res[i].data()?.publishDate);
        var year = pb_time.getFullYear();
        var month = pb_time.getMonth() + 1;
        var timeTitle = year + "-" + month;

        if (_previousItem.year != year || _previousItem.month != month) {
          _previousItem.year = year;
          _previousItem.month = month;
          _previousItem.index++;

          sortedItems = { ...sortedItems, [timeTitle]: { datas: [cardData] } };
        } else {
          sortedItems[timeTitle]?.datas.push(cardData);
        }

        //last_aid = doc.id;
      });
      //console.log(sortedItems)
      //設定卡片
      setItems(sortedItems);
      setIsBusy(false);
    });
  }

  const handleAddNewCat = (key) => {
    if (key.code == "Enter" && newCatInput != "") {
      //送出新的類別
      addNewCategory(newCatInput);
    }
  };

  if (isBusy) {
    return <>Loading...</>;
  } else
    return (
      <div className="at__root">
        {/* [按鈕] 新增文章 */}
        <AdminContent>
          <button
            class=" ui icon addButton"
            onClick={(e) => {
              window.onbeforeunload = null;
              const path = "/createArticle/";
              window.location.href = path;
            }}
          >
            <i aria-hidden="true" class="add square icon"></i>
          </button>
        </AdminContent>

        <div className="at__content-container">
          <div width={2}>
            <Menu fluid vertical tabular>
              {/* 新增分類 - 按鈕 */}
              <AdminContent>
                <Menu.Item>
                  <Button
                    onClick={() => {
                      setIsOpenNewCatInput(true);
                    }}
                  >
                    新增分類
                  </Button>

                  {/* TODO: 按下Enter送出 */}
                  <Input
                    style={{ display: isOpenNewCatInput ? "block" : "none" }}
                    value={newCatInput}
                    onChange={(e) => {
                      setNewCatInput(e.target.value);
                    }}
                    onKeyUp={(e) => handleAddNewCat(e)}
                  ></Input>
                </Menu.Item>
              </AdminContent>

              {/* 分類 */}
              <div id="at__menu-category">
                {cats?.map((item, i) => {
                  return (
                    <Menu.Item
                      color="white"
                      name={item.catName[currentLang]}
                      key={item.id}
                      active={activeItem === item.id}
                      style={{
                        color: activeItem === item.id ? "#555" : "555",
                      }}
                      onClick={() => {
                        setIsBusy(true);
                        setActiveItem(item.id);
                      }}
                    />
                  );
                })}
              </div>

              <Dropdown item text="分類" id="at__dropDown-category">
                <Dropdown.Menu>
                  {cats?.map((item, i) => {
                    return (
                      <Dropdown.Item
                        name={item.catName[currentLang]}
                        key={item.id}
                        active={activeItem === item.id}
                        onClick={() => {
                          setActiveItem(item.id);
                        }}
                      >
                        {item.catName[currentLang]}
                      </Dropdown.Item>
                    );
                  })}
                </Dropdown.Menu>
              </Dropdown>
            </Menu>
          </div>
          {/* 文章列表 */}
          <div stretched width={14} className="atl__container">
            <div>
              {Object.keys(items).map((key, i) => {
                console.log(items);
                return (
                  <AtricleTimeLine
                    dateTime={key}
                    content={items[key].datas}
                  ></AtricleTimeLine>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
}

export default ArticlesTab;
